// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";

function APlusCardNumberInput(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userAPlusCardNumber);
  var setAPlusCardNumber = match$1[1];
  var aPlusCardNumber = match$1[0];
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userAPlusCardExpiry);
  var setAPlusCardExpiry = match$2[1];
  var aPlusCardExpiry = match$2[0];
  var aPlusCardNumberRef = React.useRef(null);
  var aPlusCardExpiryRef = React.useRef(null);
  var isCardComplete = function (val) {
    return Utils$OrcaPaymentPage.onlyDigits(val).length === 16;
  };
  var getCardErrorString = function (val) {
    if (Utils$OrcaPaymentPage.onlyDigits(val) === "") {
      return "Card number cannot be empty";
    } else if (isCardComplete(val)) {
      return "";
    } else {
      return "Invalid card number";
    }
  };
  var getExpiryErrorString = function (val) {
    if (val === "") {
      return localeString.cardExpiryDateEmptyText;
    } else if (!CardUtils$OrcaPaymentPage.isExpiryComplete(val) || !CardUtils$OrcaPaymentPage.getExpiryValidity(val)) {
      return localeString.inValidExpiryErrorText;
    } else {
      return "";
    }
  };
  var changeAPlusCardNumber = function (ev) {
    var val = ev.target.value;
    var val$1 = Utils$OrcaPaymentPage.formatDigitsInGroupsOf4(val, 16);
    setAPlusCardNumber(function (param) {
          return {
                  value: val$1,
                  isValid: isCardComplete(val$1),
                  errorString: ""
                };
        });
  };
  var onBlurAPlusCardNumber = function (ev) {
    var val = ev.target.value;
    var val$1 = Utils$OrcaPaymentPage.formatDigitsInGroupsOf4(val, 16);
    setAPlusCardNumber(function (param) {
          return {
                  value: val$1,
                  isValid: isCardComplete(val$1),
                  errorString: getCardErrorString(val$1)
                };
        });
  };
  var changeAPlusCardExpiry = function (ev) {
    var val = CardValidations$OrcaPaymentPage.formatCardExpiryNumber(ev.target.value);
    setAPlusCardExpiry(function (param) {
          return {
                  value: val,
                  isValid: CardUtils$OrcaPaymentPage.isExipryValid(val),
                  errorString: ""
                };
        });
  };
  var onBlurAPlusCardExpiry = function (ev) {
    var val = CardValidations$OrcaPaymentPage.formatCardExpiryNumber(ev.target.value);
    setAPlusCardExpiry(function (param) {
          return {
                  value: val,
                  isValid: CardUtils$OrcaPaymentPage.isExipryValid(val),
                  errorString: getExpiryErrorString(val)
                };
        });
  };
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit) {
            if (!isCardComplete(aPlusCardNumber.value)) {
              setAPlusCardNumber(function (prev) {
                    var newrecord = Caml_obj.obj_dup(prev);
                    newrecord.errorString = getCardErrorString(prev.value);
                    return newrecord;
                  });
            }
            if (!CardUtils$OrcaPaymentPage.isExipryValid(aPlusCardExpiry.value)) {
              return setAPlusCardExpiry(function (prev) {
                          var newrecord = Caml_obj.obj_dup(prev);
                          newrecord.errorString = getExpiryErrorString(prev.value);
                          return newrecord;
                        });
            } else {
              return ;
            }
          }
          
        }), [
        aPlusCardNumber.value,
        aPlusCardExpiry.value
      ]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement("div", {
              className: "flex flex-col w-full",
              style: {
                gridGap: match.themeObj.spacingGridColumn
              }
            }, React.createElement("div", {
                  className: "flex gap-4 w-full"
                }, React.createElement("div", {
                      className: "w-[65%]"
                    }, React.createElement(PaymentField$OrcaPaymentPage.make, {
                          setValue: setAPlusCardNumber,
                          value: aPlusCardNumber,
                          onChange: changeAPlusCardNumber,
                          onBlur: onBlurAPlusCardNumber,
                          fieldName: "Card Number",
                          name: "aPlusCardNumber",
                          type_: "tel",
                          paymentType: "Payment",
                          maxLength: 19,
                          placeholder: "1234 5678 8765 4321",
                          inputRef: aPlusCardNumberRef
                        })), React.createElement("div", {
                      className: "w-[35%]"
                    }, React.createElement(PaymentField$OrcaPaymentPage.make, {
                          setValue: setAPlusCardExpiry,
                          value: aPlusCardExpiry,
                          onChange: changeAPlusCardExpiry,
                          onBlur: onBlurAPlusCardExpiry,
                          fieldName: "Expiry Date",
                          name: "aPlusCardExpiry",
                          type_: "tel",
                          paymentType: "Payment",
                          maxLength: 7,
                          placeholder: localeString.expiryPlaceholder,
                          inputRef: aPlusCardExpiryRef
                        }))));
}

var make = APlusCardNumberInput;

export {
  make ,
}
/* react Not a pure module */
